import type { ReactNode } from 'react';
import { AppBar } from '@mui/material';

type StickyActionsProps = {
  isActive: boolean;
  children: ReactNode;
};

const StickyActions = ({ isActive, children }: StickyActionsProps) =>
  isActive ? (
    <AppBar
      elevation={0}
      color="transparent"
      position="sticky"
      sx={{
        zIndex: (theme) => theme.zIndex.appBar - 1,
        position: { xs: 'static', lg: 'sticky' },
        top: 80,
      }}>
      {children}
    </AppBar>
  ) : (
    <>{children}</>
  );

export default StickyActions;
